export default __webpack_public_path__ + "static/media/sales-activity.f69d96f4.svg";